import script from "./MapMovement.vue?vue&type=script&lang=ts&setup=true"
export * from "./MapMovement.vue?vue&type=script&lang=ts&setup=true"

import "./MapMovement.vue?vue&type=style&index=0&id=c7dcd2fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7dcd2fa"]])

export default __exports__